import { Icon, Typography } from '@/components';
import { OfferDetails } from '../../types';
import { useTranslation } from 'react-i18next';

export type InterestSectionProps = {
  readonly offer: OfferDetails;
};

export function FeedbackSection({ offer }: InterestSectionProps) {
  const { t } = useTranslation(['offers']);

  if (!offer.rating.comments) return null;
  return (
    <section>
      <div className="mt-3">
        <div className="flex items-start gap-3">
          <div className="bg-muted flex size-9 shrink-0 items-center justify-center rounded-lg">
            <Icon name="start-rating" className="text-muted-foreground size-4" />
          </div>
          <div className="flex flex-col gap-0.5">
            <Typography as="span" size="body-3" weight="normal" className="text-muted-foreground">
              {t('Feedback submitted to this EoI')}
            </Typography>
            <Typography as="span" size="body-2" color="primary" className="whitespace-pre-line">
              {offer?.rating?.comments || 'Feedback not provided'}
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
}
